import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Layout from "@/_LayoutsRelated/layout/Layout";
import ReferralComponent from "@/pages/referral/ReferralComponent/ReferralComponent";
import { useTranslation } from "@i18n";
import MobileHeader1 from "@/_LayoutsRelated/mobileHeaders/mobileHeader1/MobileHeader1";
import useHelpers from "@hooks/useHelpers";
import { api__getReferralData } from "@/apis/refferal/refferal";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
var Referral = function Referral() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useParams = useParams(),
    orderId = _useParams.id;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var _useApi = useApi([orderId], /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _t = orderId;
            if (!_t) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return api__getReferralData(orderId);
          case 1:
            _t = _context.v;
          case 2:
            return _context.a(2, _t);
          case 3:
            _context.p = 3;
            _t2 = _context.v;
            if (_t2.name === "NotFound404Exception") {
              navigateToHard('/?ref=referral_404');
            } else {
              navigateToHard('/?ref=referral_500');
            }
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    }))),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    referralData = _useApi2[2];
  useEffect(function () {
    if (!orderId) {
      return navigateToHard("/tracking-checkout-orders");
    }
  }, [orderId]);
  if (loading || error || !referralData) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true
    // hasNavBar
    ,
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true
    // hasMobFooter
    ,
    loading: true
    // hideFooterWithoutAuthMsg
    ,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeader1, {
      title: t("who_used_referral_code", {
        ns: "web_tracking"
      }),
      buttonFunction: function buttonFunction() {
        navigateTo("/tracking-checkout-details/".concat(orderId));
      }
    })
  }, /*#__PURE__*/React.createElement(ReferralComponent, {
    referralData: referralData,
    orderId: orderId
  }));
};
export default Referral;